import ApiClient from "../utils/apiClient";

export const actionTypes = {
    SET_DEVICE_TYPE: "SET_DEVICE_TYPE",
    SET_API_URL: "SET_API_URL",
    APP_CONFIG_RECEIVED: "APP_CONFIG_RECEIVED",
    USE_DECIMAL_ODDS: "USE_DECIMAL_ODDS",
    OPEN_BOOKMAKER_SWITCHER_POPOVER: "OPEN_BOOKMAKER_SWITCHER_POPOVER",
    CLOSE_BOOKMAKER_SWITCHER_POPOVER: "CLOSE_BOOKMAKER_SWITCHER_POPOVER",
};

export const setUseDecimalOdds = (useDecimalOdds) => ({
    type: actionTypes.USE_DECIMAL_ODDS,
    useDecimalOdds,
});

export const setDeviceType = (isPhone, isTablet) => ({
    type: actionTypes.SET_DEVICE_TYPE,
    isPhone,
    isTablet,
});

export const setApiUrl = (apiUrl, apiV3Url) => ({
    type: actionTypes.SET_API_URL,
    apiUrl,
    apiV3Url,
});

export const appConfigReceived = (config, isPhone) => ({
    type: actionTypes.APP_CONFIG_RECEIVED,
    isPhone,
    config,
});

export const openBookmakerSwitcherPopover = () => ({
    type: actionTypes.OPEN_BOOKMAKER_SWITCHER_POPOVER,
});

export const closeBookmakerSwitcherPopover = () => ({
    type: actionTypes.CLOSE_BOOKMAKER_SWITCHER_POPOVER,
});

export const loadAppConfig = (isPhone) => (dispatch) =>
    ApiClient.loadAppConfig()
        .then((data) => {
            dispatch(appConfigReceived(data, isPhone));
        })
        .catch((err) => {
            console.error("An error occured", err);
        });


// WEBPACK FOOTER //
// /src/js/common/pageInfo/pageInfo.actions.js